import React from 'react';
import RevyMark from '../../assets/revy/revy-mark-dark.png';

/** The REVY mark that opens every assistant turn. */
const ChatAssistantAvatar: React.FC = () => (
  <img
    src={RevyMark}
    alt=""
    aria-hidden
    className="mt-0.5 size-6 shrink-0 rounded-full object-contain"
  />
);

export default ChatAssistantAvatar;
